import { render, staticRenderFns } from "./Parceiros.vue?vue&type=template&id=da1212fe"
import script from "./Parceiros.vue?vue&type=script&lang=ts"
export * from "./Parceiros.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports